/**
 * Client-side instrumentation for Next.js.
 * This module is imported by the application's instrumentation-client.ts file.
 * PostHog handles both analytics and error tracking (replaces Sentry).
 */

import { isPostHogEnabled } from "./env";
import { initPostHogClient } from "./posthog/client";

export interface InstrumentationClientConfig {
  posthog?: {
    apiKey: string;
    apiHost?: string;
    uiHost?: string;
    debug?: boolean;
  };
}

/**
 * Initialize client-side analytics.
 *
 * @param config - Configuration for analytics services
 */
export function initClientAnalytics(config: InstrumentationClientConfig): void {
  if (config.posthog && isPostHogEnabled()) {
    initPostHogClient(config.posthog.apiKey, {
      apiHost: config.posthog.apiHost,
      uiHost: config.posthog.uiHost,
      debug: config.posthog.debug,
    });
  }
}

/**
 * No-op router transition handler for API compatibility.
 * Previously this was Sentry.captureRouterTransitionStart.
 * PostHog tracks pageviews automatically via the defaults: "2025-11-30" setting.
 */
export const onRouterTransitionStart = (): void => {};
